import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/Card';

export function PendingApprovalPage() {
  const { firebaseUser, appUser, signOut, computeLandingRoute } = useAuth();
  const navigate = useNavigate();
  const isPending =
    appUser?.status === 'pending' || (appUser?.companyId == null && appUser?.role !== 'owner');

  useEffect(() => {
    if (appUser && !isPending) {
      navigate(computeLandingRoute(appUser), { replace: true });
    }
  }, [appUser, isPending, computeLandingRoute, navigate]);

  const email = firebaseUser?.email ?? appUser?.email ?? '';

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Cuenta pendiente de aprobación</CardTitle>
          <CardDescription>
            Tu cuenta está pendiente de asignación a una empresa. Contacta a tu administrador o
            espera la aprobación.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {email && (
            <p className="rounded-md bg-muted px-3 py-2 text-sm text-muted-foreground">
              Sesión iniciada como: <strong className="text-foreground">{email}</strong>
            </p>
          )}
          <Button variant="outline" className="w-full" onClick={() => signOut()}>
            Cerrar sesión
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
